<script setup>
import { throttle } from "lodash-es";
import { onBeforeUnmount, onMounted, ref } from "vue";

import { router } from "@inertiajs/vue3";

const props = defineProps({
  id: {
    type: String,
    required: true
  },
  as: {
    type: String,
    default: "div"
  },
  containerClass: {
    type: String,
    default: ""
  }
});

const scrollContainer = ref(null);

const getStorageKey = () => `preserved_scroll_${props.id}`;

// 스크롤 이벤트 핸들러
const handleScroll = throttle(() => {
  if (scrollContainer.value) {
    const position = scrollContainer.value.scrollLeft;
    sessionStorage.setItem(getStorageKey(), position);
  }
}, 100);

const restoreScrollPosition = () => {
  if (scrollContainer.value) {
    const savedPosition = sessionStorage.getItem(getStorageKey());

    if (savedPosition !== null) {
      scrollContainer.value.scrollLeft = parseInt(savedPosition);
    }
  }
};

const setupInertiaListeners = () => {
  router.on("finish", () => {
    restoreScrollPosition();
  });
};

onMounted(() => {
  restoreScrollPosition();
  setupInertiaListeners();
});

onBeforeUnmount(() => {
  handleScroll.cancel();
});
</script>
<template>
  <component :is="as" ref="scrollContainer" :class="['overflow-x-scroll scrollbar-hide', containerClass]" @scroll="handleScroll">
    <slot></slot>
  </component>
</template>
